import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import CheckWallet from './Components/CheckWallet/CheckWallet';
import Footer from './Components/Footer/Footer';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import HomePage from './Components/HomePage/HomePage';
import { Route, Routes } from 'react-router-dom';
import Header from './Components/Header/Header';
import Staking from './Components/Staking/Staking';


function App() {
  useEffect(() => {
    const modal = document.querySelector(".w3m-overlay");
    if (modal) {
      modal.style.zIndex = "10000000";
    }
  }, []);

  return (
    <div className="App">
      <Toaster />
<Header/>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* <Route path="/CheckWallet" element={<CheckWallet />} /> */}
        <Route path="/Staking" element={<Staking />} />
      </Routes>

 
   
   
    <Footer/>

    </div>
  );
}

export default App;
